import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Divider, Tab } from '@material-ui/core';
import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { useLocation } from 'react-router-dom';
import { useChangelog } from 'hooks';
import VersioningPage from './VersioningPage';

enum TabLabels {
  PrivacyPolicy = 'privacy_policy',
  CGU = 'cgu',
  Versioning = 'versioning',
}

export const TAB_PANEL_PARAM = 'tabPanelValue';

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const InfoPage: React.FC = () => {
  const { t: pt } = useTranslation('translation', { keyPrefix: 'infoPage' });
  const tabPanelValue = useQuery()?.get(TAB_PANEL_PARAM);
  const [selectedTab, setSelectedTab] = useState(tabPanelValue ?? TabLabels.Versioning);
  const { value: changelogs } = useChangelog(new Date());

  return (
    <Box maxWidth="90%">
      <TabContext value={selectedTab}>
        <TabList
          value={selectedTab}
          onChange={(e, newValue) => {
            setSelectedTab(newValue);
          }}
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab label={pt('tabs.privacyPolicy')} value={TabLabels.PrivacyPolicy} disabled />
          <Tab label={pt('tabs.cgu')} value={TabLabels.CGU} disabled />
          <Tab label={pt('tabs.versioning')} value={TabLabels.Versioning} />
        </TabList>
        <Divider />
        <TabPanel value={TabLabels.PrivacyPolicy}></TabPanel>
        <TabPanel value={TabLabels.CGU}></TabPanel>
        <TabPanel value={TabLabels.Versioning}>
          <VersioningPage changelogs={changelogs} />
        </TabPanel>
      </TabContext>
    </Box>
  );
};
export default InfoPage;
